var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "params-form-panel" }, [_c('div', { staticClass: "params-form-panel-hd" }, [_c('span', { staticClass: "params-form-panel-title" }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('span', { staticClass: "params-form-panel-action-bar" }, [_vm._t("action-bar")], 2)]), _vm._v(" "), _c('div', { staticClass: "params-form-panel-bd" }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };